import { render, staticRenderFns } from "./locapromotion.vue?vue&type=template&id=2b9db628&"
import script from "./locapromotion.vue?vue&type=script&lang=js&"
export * from "./locapromotion.vue?vue&type=script&lang=js&"
import style0 from "./locapromotion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports